<h2>Doładowania konta</h2>

<div class="filters">
  <p-checkbox [(ngModel)]="onlyWithoutInvoice" [binary]="true" label="Pokaż tylko doładowania bez faktury"
    (onChange)="onFilterChange()"></p-checkbox>
</div>

<p-table [value]="prepaids" *ngIf="!isLoading && prepaids.length > 0">
  <ng-template pTemplate="header">
    <tr>
      <th>Data płatności</th>
      <th>Klient</th>
      <th>Kwota</th>
      <th>Status faktury</th>
      <th>Akcje</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-prepaid>
    <tr>
      <td>{{ prepaid.created_at | date:'dd.MM.yyyy, HH:mm' }}</td>
      <td>
        {{ prepaid.user?.user_details?.name }} {{ prepaid.user?.user_details?.surname }}<br>
        <small>{{ prepaid.user?.email }}</small>
      </td>
      <td>{{ prepaid.amount | currencyReduce:true | currency:'PLN' }}</td>
      <td>
        <span *ngIf="prepaid.manual_invoice" class="status status--done">Faktura dodana</span>
        <span *ngIf="!prepaid.manual_invoice" class="status status--pending">Wymaga faktury</span>
      </td>
      <td class="actions">
        <input #invoiceInput type="file" accept="application/pdf,.pdf" hidden
          (change)="onFileChange($event, prepaid)">
        <button pButton type="button"
          [label]="prepaid.manual_invoice ? 'Podmień fakturę' : 'Dodaj fakturę'"
          (click)="openFilePicker(invoiceInput)"
          [disabled]="uploadingPrepaidId === prepaid.id || deletingPrepaidId === prepaid.id">
        </button>
        <button *ngIf="prepaid.manual_invoice" pButton type="button" class="ui-button-secondary"
          label="Pobierz" (click)="downloadInvoice(prepaid)">
        </button>
        <button *ngIf="prepaid.manual_invoice" pButton type="button" class="ui-button-danger"
          label="Usuń" (click)="deleteInvoice(prepaid)" [disabled]="deletingPrepaidId === prepaid.id">
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>

<div *ngIf="!isLoading && prepaids.length === 0" class="empty-state">
  {{ onlyWithoutInvoice ? 'Brak opłaconych doładowań wymagających dodania faktury.' : 'Brak opłaconych doładowań.' }}
</div>

<app-loader *ngIf="isLoading"></app-loader>

<p-paginator *ngIf="!isLoading && data?.total > data?.per_page" [rows]="data.per_page" [totalRecords]="data.total"
  (onPageChange)="onPaginate($event)"></p-paginator>
